// extracted by mini-css-extract-plugin
module.exports = {"select":"origin_select__2B3i_","cards":"origin_cards__3arc_","isSearch":"origin_isSearch__qtZzQ"};